import { URL_API } from 'src/configs/keys'
import httpService from 'src/helpers/httpService'
import baseActions from 'src/helpers/redux/baseActions'

const master = 'master'
const profession = 'profession'
const levelArea = 'level-area'
const memberType = 'member-type'

export const actionType = (action) => {
  return {
    request: `${action}_${master}_request`.toUpperCase(),
    success: `${action}_${master}_success`.toUpperCase(),
    error: `${action}_${master}_error`.toUpperCase(),
  }
}

const request = httpService()

export default {
  ...baseActions(master, URL_API, actionType),
  fetchProfession: (params) => {
    return (dispatch) => {
      dispatch({ type: actionType('fetchProfession').request })
      return request.get(`${URL_API}/${master}/${profession}`, { params }).then(
        (response) => {
          return response.data
        },
        (error) => {
          throw error.response
        },
      )
    }
  },
  fetchDPD: (params) => {
    return (dispatch) => {
      dispatch({ type: actionType('fetchDPD').request })
      return request.get(`${URL_API}/${master}/${levelArea}`, { params }).then(
        (response) => {
          return response.data
        },
        (error) => {
          throw error.response
        },
      )
    }
  },
  fetchMemberType: (params) => {
    return (dispatch) => {
      dispatch({ type: actionType('fetchMemberType').request })
      return request.get(`${URL_API}/${master}/${memberType}`, { params }).then(
        (response) => {
          return response.data
        },
        (error) => {
          throw error.response
        },
      )
    }
  },
}
